export default "__VITE_ASSET__xwQ1vst2__"